import { asyncAction } from 'lib/actions';

export const fetchConditionAction = asyncAction('condition/FETCH');
